import { helpers, required } from '@vuelidate/validators'
import { ECountry } from './useNip.types'
import type { TInstance } from '@/components/Inputs/Composables/validators/validators.types'

export function useNip(
  field: string,
  country: ECountry | Ref<ECountry> | ComputedRef<ECountry>,
  t: TInstance,
) {
  const getCountry = (): ECountry => (isRef(country) ? country.value : country)

  const nipValidator = helpers.withMessage(
    () => t('formValidatorMessages.nip.invalid'),
    (value: string) => {
      const currentCountry = getCountry()

      if (/[ \t\r\n-]/.test(value)) return false
      if (!currentCountry) return false

      if (currentCountry === ECountry.POLAND) {
        if (!/^\d{10}$/.test(value)) return false
        if (value.length !== 10) return false
        if (/^0{10}$/.test(value)) return false
  
        const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7]
        const sum = weights.reduce(
          (acc, w, i) => acc + w * Number(value[i]),
          0,
        )
  
        const control = sum % 11
        return control === Number(value[9])
      }
  
      return /^[A-Z]{2}[0-9]{2,12}$/.test(value.toUpperCase())
    },
  )

  return ({
    [`${field}`]: {
      required: helpers.withMessage(
        () => t('formValidatorMessages.nip.required'),
        required,
      ),
      nipValidator,
    },
  })
}
